export const LOCALES = {
   RUSSIAN: 'ru-RU',
   ENGLISH: 'en-US',
}